import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewEncapsulation,
  OnChanges,
  SimpleChanges,
  ChangeDetectionStrategy,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import moment from 'moment-timezone';

@Component({
  selector: 'time-picker',
  templateUrl: './time-picker.component.html',
  styleUrls: ['./time-picker.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class TimePickerComponent implements OnInit, OnChanges {
  @Input() public time: string = 'Send Time';
  @Input() public placeholder: string;
  @Input() public disabled: boolean;
  @Input() public validationControl: FormControl;

  // Accepts a string that will be the earliest time displayed
  @Input() startTimeRestriction;
  // Accepts a string that will be the latest time displayed
  @Input() public endTimeRestriction;
  @Input() public disabledTimes: string[];

  @Output() public timeSelected = new EventEmitter();

  public allTimeOptions;
  public displayTimes;

  public ngOnInit() {
    this.allTimeOptions = [];
    for (let i = 0; i < 24; i++) {
      let hour = (i === 0 ? 12 : (i > 12 ? i % 12 : i));
      for (let j = 0; j <= 3; j++) {
        let timeStr = hour + ':' + ((j * 15) === 0 ? '00' : (j * 15)) + (i < 12 ? ' am' : ' pm');
        this.allTimeOptions.push(timeStr);
      }
    }
    this.displayTimes = this.allTimeOptions;
  }

  public ngOnChanges(changes: SimpleChanges) {
    const disabledInputChanged = 'disabled' in changes;
    const controlChangedWhileDisabledBound = 'validationControl' in changes && this.disabled !== undefined;
    if ((disabledInputChanged || controlChangedWhileDisabledBound) && this.validationControl) {
      if (this.disabled) {
        this.validationControl.disable();
      } else {
        this.validationControl.enable();
      }
    }
  }

  public checkTimeDisabled(time: string) {
    let disabled = false;
    const timeFormat = 'h:mm a';
    if (this.startTimeRestriction) {
      disabled = moment(time, timeFormat).isBefore(moment(this.startTimeRestriction, timeFormat));
    }
    if (!disabled && this.endTimeRestriction) {
      disabled = moment(time, timeFormat).isAfter(moment(this.endTimeRestriction, timeFormat));
    }
    if (!disabled && this.disabledTimes) {
      disabled = this.disabledTimes.includes(time);
    }
    return disabled;
  }
}
